# Состав коллекции для панели ChildrenContents в форме (порт референсного
# ChildrenContentsQuery: contents(collectionId:) + nestedSortValue)
query ChildrenContents(
  $page: Int
  $rowsPerPage: Int
  $collectionId: ID!
  $sort: ContentsSortType
) {
  contents(
    page: $page
    rowsPerPage: $rowsPerPage
    collectionId: $collectionId
    sort: $sort
  ) {
    count
    nodes {
      id
      type
      title
      publishAt
      duration
      preview {
        id
        url(format: SMALL)
      }
      playback {
        hlsUrl
        thumbnailUrl
      }
      nestedSortValue(collectionId: $collectionId)
      totalViews
    }
  }
}
